import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Features from '../components/Features';
import Commands from '../components/Commands';
import About from '../components/About';
import FAQ from '../components/FAQ';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Stats />
      <Features />
      <Commands />
      <About />
      <FAQ />
    </div>
  );
};

export default Home;
